import React, { useState, useEffect, useCallback } from "react";
import { db } from "../../utils/firebase";
import { getBeefBatches } from "../../utils/beef";
//imported the scan_bkgrd.jpg and named it 'scanBg'
import scanBg from "../../img/scan_bkgrd.jpg";
//imported the scan_bkgrd_blue.png and named it 'squareBg'
import squareBg from "../../img/scan_bkgrd_blue.png"
import {
  collection,
  addDoc,
  getDocs,
  query,
  orderBy,
  limit,
  where,
  Timestamp,
} from "firebase/firestore";
import useTimer from "../../utils/timer";
import QRScanner from "../../components/QRScanner";

const GamePage = () => {
  const [isGameStarted, setIsGameStarted] = useState(false);
  const [isGameFinished, setIsGameFinished] = useState(false);
  const [infectedBatches, setInfectedBatches] = useState([]);
  const [scannedBatches, setScannedBatches] = useState([]);
  const [playerName, setPlayerName] = useState("");
  const [yourRank, setYourRank] = useState(null);
  const [scanMessage, setScanMessage] = useState("");
  const [isNameSubmitted, setIsNameSubmitted] = useState(false);
  const [isCameraReady, setIsCameraReady] = useState(false);
  const [shouldRun, setShouldRun] = useState(false);
  const [elapsedTime, resetTimer] = useTimer(shouldRun);
  const [allScannedBatches, setAllScannedBatches] = useState([]);

  

  useEffect(() => {
    const fetchBatches = async () => {
      try {
        const { infectedBatchIDs } = await getBeefBatches();
        setInfectedBatches(infectedBatchIDs);
      } catch (error) {
        console.error("Error fetching batches:", error);
      }
    };
    fetchBatches();
  }, []);

  const handleScan = useCallback(
    (data) => {
      if (data && data.text) {
        try {
          const url = new URL(data.text.trim());
          const batchId = url.pathname.split("/").pop();
  
          // Track all scanned QR codes
          setAllScannedBatches((prevAllScannedBatches) => {
            if (!prevAllScannedBatches.includes(batchId)) {
              return [...prevAllScannedBatches, batchId];
            }
            return prevAllScannedBatches; // Avoid duplicates
          });
  
          // Track infected batches specifically
          if (
            infectedBatches.includes(batchId) &&
            !scannedBatches.includes(batchId)
          ) {
            setScannedBatches((prevScannedBatches) => [
              ...prevScannedBatches,
              batchId,
            ]);
  
            if (scannedBatches.length + 1 === infectedBatches.length) {
              setShouldRun(false);
              setIsGameStarted(false);
              setIsGameFinished(true);
              setScanMessage("");
            } else {
              setScanMessage(`Batch ${batchId} is infected!`);
            }
          } else if (!infectedBatches.includes(batchId)) {
            setScanMessage(`Batch ${batchId} is not infected.`);
          }
        } catch (error) {
          console.error("Invalid URL scanned:", error);
        }
      }
    },
    [infectedBatches, scannedBatches]
  );

  

  const handleCameraReady = useCallback(() => {
    setIsCameraReady(true);
    setShouldRun(true);
  }, []);

  const startGame = () => {
    setIsGameStarted(true);
    setIsGameFinished(false);
    setScannedBatches([]);
    setPlayerName("");
    setScanMessage("");
    setIsNameSubmitted(false);
    setIsCameraReady(false);
    setShouldRun(false);
    resetTimer();
  };

  const endGame = async () => {
    setShouldRun(false);
    const timeSpent = elapsedTime.toFixed(3);
    const gameCode = Math.random().toString(36).substr(2, 9);
    const completionDateTime = Timestamp.fromDate(new Date());

    try {
      await addDoc(collection(db, "leaderboard"), {
        name: playerName,
        timeSpent: parseFloat(timeSpent),
        gameCode,
        completionDateTime,
      });

      const allTimeRankSnapshot = await getDocs(
        query(collection(db, "leaderboard"), orderBy("timeSpent"))
      );

      const pastHourRankSnapshot = await getDocs(
        query(
          collection(db, "leaderboard"),
          where(
            "completionDateTime",
            ">",
            Timestamp.fromDate(new Date(Date.now() - 60 * 60 * 1000))
          ),
          orderBy("timeSpent")
        )
      );

      const allTimeRank = allTimeRankSnapshot.docs.findIndex(
        (doc) => doc.data().gameCode === gameCode
      );
      const pastHourRank = pastHourRankSnapshot.docs.findIndex(
        (doc) => doc.data().gameCode === gameCode
      );

      setYourRank({
        allTimeRank: allTimeRank + 1,
        pastHourRank: pastHourRank + 1,
        timeSpent,
        completionDateTime: new Date(
          completionDateTime.seconds * 1000
        ).toLocaleString(),
      });

      setIsNameSubmitted(true);
    } catch (error) {
      console.error("Error saving to leaderboard:", error);
    }
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = (seconds % 60).toFixed(3);
    return `${mins}:${secs < 10 ? "0" : ""}${secs}`;
  };

  return (
    //added style={{ backgroundImage: `url(${ScanBackground})` }} the <div> to add background scan_bkgrd.jpg image
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100" style={{ backgroundImage: `url(${scanBg})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>
      {!isGameStarted && !isGameFinished ? (
        <>
          <div className="w-full max-w-md p-4 bg-white rounded-lg shadow-md mb-6">
            <h2 className="text-xl font-semibold mb-4 text-center">
              Welcome to the Beef Supply Chain Tracker!
            </h2>
            <p className="text-center mb-4">
              Use blockchain technology to track beef batches. <br></br>
              Some batches have mad cow disease. <br></br>Your task is to scan
              QR codes and find the infected ones.
            </p>
            <p className="text-center mb-4">
              Be quick and top the leaderboard!
            </p>
          </div>

          <button
            onClick={startGame}
            className="bg-blue-500 text-white px-6 py-3 rounded-lg shadow-md"
          >
            Start Game
          </button>
        </>
      ) : !isNameSubmitted ? (
        //removed 'bg-white rounded-lg shadow-md' and changed to 'w-full max-w-xl p-8' and added 'style={{ backgroundImage: `url(${squareBg})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}' to make sure the square remains even in the mobile site in div classname
        
          <div className={"w-full max-w-xl"}>
          <div className="text-lg font-semibold mb-8 text-white text-left pl-8 w-11/12" style={{ padding: "auto"}}>
          <p>
            Elapsed time: {formatTime(elapsedTime)}
          </p>
            
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p>
              {scannedBatches.length} / {infectedBatches.length} found
            </p>
            <p>
              Total scanned: {allScannedBatches.length}
            </p>
          </div>

            <p className={scanMessage.includes("not infected") ? "text-green-700 bg-green-200 border border-green-400 rounded"  : "text-red-700 bg-red-200 border border-red-400 rounded"}>{scanMessage}</p>
          </div>
            {isGameStarted && (
              <div className="flex justify-center">
                <QRScanner
                  handleScan={handleScan}
                  onCameraReady={handleCameraReady}
                  //className="w-64 h-64"
                />
              </div>
            
          )}
          {isGameFinished && (
            <div className="flex flex-col items-center">
              <input
                type="text"
                value={playerName}
                onChange={(e) => setPlayerName(e.target.value)}
                placeholder="Enter your name"
                className="border p-2 mb-4 w-full rounded"
              />
              <button
                onClick={endGame}
                className="bg-green-500 text-white px-6 py-3 rounded-lg shadow-md"
              >
                Submit
              </button>
            </div>
          )}
        </div>
      
      ) : (
        yourRank && (
          <div className="w-full max-w-md p-4 bg-white rounded-lg shadow-md mt-6">
            <h2 className="text-xl font-semibold mb-4 text-center">
              Congratulations!
            </h2>
            <div className="flex flex-col items-center mb-4">
              <p className="text-lg">Your Time: {yourRank.timeSpent} seconds</p>
              <p className="text-lg">All-Time Rank: {yourRank.allTimeRank}</p>
              <p className="text-lg">Past Hour Rank: {yourRank.pastHourRank}</p>
              <p className="text-lg">
                Completion Date & Time: <br></br>
                {yourRank.completionDateTime}
              </p>
            </div>
            <div className="flex flex-col space-y-2">
              <button
                onClick={startGame}
                className="bg-blue-500 text-white px-6 py-3 rounded-lg shadow-md"
              >
                Play Again
              </button>
              <button
                onClick={() => (window.location.href = "/leaderboards")}
                className="bg-blue-500 text-white px-6 py-3 rounded-lg shadow-md"
              >
                View Leaderboard
              </button>
            </div>
          </div>
        )
      )}
    </div>
  );
};

export default GamePage;
